<template>
  <div
    class="w-full flex  items-center"
    :class="
      direction === 'col'
        ? 'flex-col justify-center items-center'
        : 'md:flex-row flex-col lg:justify-end'
    "
  >
    <img
      :src="require('@/assets/images/skyscanner-logo.webp')"
      :alt="
        $t('magazine.widgetAlt.logoIcon', {
          socialMedia: 'Skyscanner'
        })
      "
      class="skyscanner-img md:pb-0 pb-2"
      :class="direction === 'col' ? 'mb-6 ml-0' : 'lg:mb-0 lg:ml-[18px]'"
      loading="lazy"
    />
    <div
      class="opacity-topaz-light"
      :class="direction === 'col' ? 'ml-0' : 'md:ml-8'"
    >
      <wegow-button
        button-id="skyscanner-btn"
        class="hidden md:inline-block"
        :class="direction === 'col' ? 'ml-0' : ''"
        color="white"
        background="transparent"
        border="topaz"
        custom-padding="6px 23px"
        :text="$t('profiles.buttons.findYourTrip')"
        @click="redirect(), gaEvent()"
      />
      <wegow-button
        button-id="skyscanner-btn"
        class="md:hidden inline-block"
        :class="direction === 'col' ? 'ml-0' : ''"
        color="topaz-light"
        background="opacity"
        custom-padding="6px 23px"
        :text="$t('profiles.buttons.findYourTrip')"
        @click="redirect(), gaEvent()"
      />
    </div>
  </div>
</template>

<script setup>
import { event } from "vue-gtag";
import WegowButton from "@/components/general/forms/WegowButton";

const props = defineProps({
  eventDetail: {
    type: Object,
    default: undefined
  },
  direction: {
    type: String,
    default: ""
  }
});

const gaEvent = () => {
  event("Skyscanner", {
    event_category: "transport"
  });
};
const redirect = () => {
  window.open("https://skyscanner.pxf.io/OrJM1K", "_blank");
};
</script>

<style lang="scss" scoped>
.opacity-topaz-light {
  font-size: 16px;
  @media screen and (min-width: $screen-md) {
    font-size: 20px;
  }
}
.skyscanner-img {
  height: 36px;
  width: 161px;
  margin-bottom: 18px;
  @media screen and (min-width: $screen-lg) {
    height: 29px;
  }
}
</style>
